import React, { Component } from 'react';
import { FormGroup, ControlLabel, Col, FormControl, HelpBlock } from 'react-bootstrap';
import get from 'lodash/get';

export default class FourField extends Component {

 constructor(props) {
   super(props);
   this.state = props.input.value || {};
 }

  onInputChange(name, e) {
    const { input: { onChange } } = this.props;
    const value = e.target.value;
    
    this.setState({ ...this.state, [name]: value }, () => {
      onChange(this.state);
    });
  }

  render() {
    const { 
      input, 
      meta: { error, touched }, 
      label, 
      id, 
      layout
    } = this.props;

    const showError = error && touched;

    const top = get(input, 'value.top', '0');
    const right = get(input, 'value.right', '0');
    const bottom = get(input, 'value.bottom', '0');
    const left = get(input, 'value.left', '0');
    
    const inputBlock = (namespace) => {
      return (
        <div className="row">
          <div className="col-sm-3 text-center">
            <label htmlFor="top" className="control-label">Top</label>
            <FormControl
              componentClass='input'
              type='number' 
              placeholder='top' 
              onChange={this.onInputChange.bind(this, 'top')}
              name='top'
              value={top}
              autoComplete='off'
              id={`${namespace}[top]`}
            />
          </div>

          <div className="col-sm-3 text-center">
            <label htmlFor="right" className="control-label">Right</label>
            <FormControl
              componentClass='input'
              type='number' 
              placeholder='right' 
              onChange={this.onInputChange.bind(this, 'right')} 
              name='right'
              value={right}
              autoComplete='off'
              id={`${namespace}[right]`}
            />
          </div>

          <div className="col-sm-3 text-center">
            <label htmlFor="bottom" className="control-label">Bottom</label>
            <FormControl
              componentClass='input'
              type='number' 
              placeholder='bottom' 
              onChange={this.onInputChange.bind(this, 'bottom')} 
              name='bottom'
              value={bottom}
              autoComplete='off'
              id={`${namespace}[bottom]`}
            />
          </div>

          <div className="col-sm-3 text-center">
            <label htmlFor="left" className="control-label">Left</label>
            <FormControl
              componentClass='input'
              type='number' 
              placeholder='left' 
              onChange={this.onInputChange.bind(this, 'left')} 
              name='left'
              value={left}
              autoComplete='off'
              id={`${namespace}[left]`}
            />
          </div>

          <FormControl.Feedback />
          <HelpBlock>{showError ? error : ''}</HelpBlock>
        </div>
      );
    };

    if (layout === 'horizontal') {
      return (
        <FormGroup validationState={showError ? 'error' : null}>
          <Col componentClass={ControlLabel} xs={3} className="control-label-horizontal">
            {label}
          </Col>
          <Col xs={9}>
            {inputBlock(id || input.name)}
          </Col>
        </FormGroup>
      );
    }

    return (  
      <FormGroup
        className={label ? 'label-present' : 'label-blank'} 
        validationState={showError ? 'error' : null}
      > 
        {label ? <ControlLabel>{label}</ControlLabel> : ''}
        {inputBlock(id || input.name)}
      </FormGroup>
    );
  }
}
